import React from "react";
import "./PublicSite.css";

const PublicFooter: React.FC = () => (
  <footer className="public-footer">
    <div className="public-footer__inner">
      <p>&copy; {new Date().getFullYear()} ASD Parco della Sciola.<br />Tutti i diritti riservati.</p>
      <div className="public-footer__socials" aria-label="Seguici sui social">
        <a href="https://www.instagram.com/asdparcodellasciola/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram">
          <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" />
          </svg>
        </a>
        <a href="https://www.facebook.com/p/ASD-Parco-della-Sciola-100052214144813/?locale=it_IT" target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook">
          <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
            <path d="M15 8h-2a1 1 0 0 0-1 1v2h3l-.5 3h-2.5v6h-3v-6H8v-3h2V9a3 3 0 0 1 3-3h2v2z" fill="var(--public-paper)" />
          </svg>
        </a>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
